<p-card styleClass="p-3 very-compact-card mb-3">
  <p-steps
    [model]="steps"
    [activeIndex]="activeIndexStep"></p-steps>
</p-card>

<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <ng-container *ngIf="!activeIndexStep">
            <div class="field">
              <label class="font-medium required-field">Email</label>
              <crm-input-text
                [(value)]="email.email"
                [isError]="$any(errorEmail?.email)"></crm-input-text>
              <small
                *ngIf="errorEmail?.email"
                class="p-error">
                {{ errorEmail?.email | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 1">
            <div class="field">
              <label class="font-medium required-field">Имя</label>
              <crm-input-text
                [(value)]="profileRegister.firstName"
                [isError]="$any(errorProfileRegister?.firstName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.firstName"
                class="p-error">
                {{ errorProfileRegister?.firstName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Фамилия</label>
              <crm-input-text
                [(value)]="profileRegister.lastName"
                [isError]="$any(errorProfileRegister?.lastName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.lastName"
                class="p-error">
                {{ errorProfileRegister?.lastName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Отчество</label>
              <crm-input-text
                [(value)]="profileRegister.middleName"
                [isError]="$any(errorProfileRegister?.middleName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.middleName"
                class="p-error">
                {{ errorProfileRegister?.middleName | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 2">
            <div class="field">
              <label class="font-medium required-field">Клиент</label>
              <crm-client-auto-complete
                [(selectedClient)]="user.client"
                [isError]="$any(errors?.client)"
                [customSearch]="false"
                [showClear]="true"
                appendTo="body"></crm-client-auto-complete>
              <small
                *ngIf="errors?.client"
                class="p-error">
                {{ errors.client | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Должность</label>
              <crm-input-text
                [(value)]="user.job"
                [isError]="$any(errors?.job)"></crm-input-text>
              <small
                *ngIf="errors?.job"
                class="p-error">
                {{ errors.job | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Контрагент</label>
              <crm-contragent-multi-select
                [clientIds]="[user.client?.id]"
                [(selectedEntities)]="user.contragents"
                [isError]="$any(errors?.client)"
                appendTo="body"></crm-contragent-multi-select>
              <small
                *ngIf="errors?.contragents"
                class="p-error">
                {{ errors.contragents | join }}
              </small>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                [(ngModel)]="user.isMailingEnabled"
                [binary]="true"
                inputId="isMailingEnabled"></p-checkbox>
              <label [for]="'isMailingEnabled'">Включить в рассылку</label>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                [(ngModel)]="user.invite"
                [binary]="true"
                inputId="invite"></p-checkbox>
              <label [for]="'invite'">Доступ в личный кабинет</label>
            </div>
          </ng-container>
        </div>
      </p-card>

      <crm-external-user-permissions-widget
        *ngIf="user?.accessControl && !user.accessControl.admin"
        styleClass="mt-3"
        [user]="user"
        (accessChange)="updatePermissions($event)"></crm-external-user-permissions-widget>
    </div>
  </div>

  <div class="mt-3">
    <crm-button
      [label]="activeIndexStep === 2 ? 'Добавить' : 'Далее'"
      styleClass="p-button-success mr-2"
      (onClick)="saveUser()"></crm-button>

    <crm-button
      *ngIf="activeIndexStep"
      icon="pi pi-arrow-left"
      label="Назад"
      styleClass="p-button-text p-button-secondary"
      (onClick)="back()"></crm-button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
